import { CryptDecrypt } from "../../Elements/crypt/Crypt";

/**
 * Checks if at least one given permission key in a specific section is not 0.
 * @param section - e.g. "Arbeitszeiterfassung"
 * @param keys - array of permission keys to check
 */
const CheckPermissions = (section: string, keys: string[]) => {
    const item = localStorage.getItem('userPermission');
    if (!item) return false;

    const data = JSON.parse(CryptDecrypt(item) as string);
    const permissions = data[section];
    if (!permissions) return false;

    let check = 0;
    for (const key of keys) {
        if (permissions[key] !== undefined && permissions[key] !== 0 && permissions[key] !== null) {
            check++;
        }
    }

    return check !== 0;
};

export default CheckPermissions;
